export const ADMIN_EMAIL_KEY = "admin-email";
export const ADMIN_USER_ID_KEY = "admin-user-id";
export const CONTRACT_TOKEN_KEY = "contract-token";
